import { ActivityLogEvent } from '@/constants/activityLogEvent';

const hiddenTimelineEvents: (ActivityLogEvent | string)[] = [
  ActivityLogEvent.has_completed_reward_card_tutorial,
  ActivityLogEvent.classification_changed,
  ActivityLogEvent.CLASSIFICATION_CHANGED_EVENT
];

export default hiddenTimelineEvents;
